<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/f9iHFo/tc-custom/9780544130166.jpg?1694660085593" alt="This image is the cover for the book We That Are Left"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">We That Are Left
      </h1>
      <p class="bookDescription body article font2">
        <b>A saga of a British family and the Great War from </b><b>“one of those writers who can see into the past and help us feel its texture” (Hilary Mantel).</b><br/>  <br/> Growing up at Ellinghurst, their crumbling family estate, all three Melville children dream of escape. Headstrong Jessica yearns for the glitter and glamour of London, while Phyllis longs to attend university. The adored Theo, meanwhile, eclipses everyone around him. But none of the children take much notice of Oskar Grunewald, their mother’s science-obsessed godson, who seeks refuge in Ellinghurst’s enormous library.<br/>  <br/> Then the cataclysm of the Great War devastates the Melvilles’ lives and reshapes their futures, and Jessica and Phyllis must forge new paths in a world that no longer plays by the old rules. As Oskar is drawn reluctantly back into the Melville family fold, his life entwines with theirs in ways that will transform them forever.<br/>  <br/> One of the <i>Washington Post</i>’s Notable Fiction Books of 2015 and a <i>New York Times</i> Editor’s Choice, <i>We That Are Left</i> is “[a] lavishly detailed historical novel that doesn’t just recreate the past but alters your perception of it” (<i>The </i><i>New York Times Book Review</i>).<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clare Clark
      </h2>
      
      <p class="authorDescription body article">Clare Clark is the author of four novels, including <I>The Great Stink</I>, which was long-listed for the Orange Prize and named a <I>Washington Post</I> Best Book of the Year, and <I>Savage Lands</I>, also long-listed for the Orange Prize. Her work has been translated into five languages. She lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5fc028ba